// extracted by mini-css-extract-plugin
export var active = "_dt-2";
export var recordingDot = "_dt-1";
export var recordingIndicator = "_dt-0";